import {createContext} from 'react';

const IsSummaryViewContext = createContext(false);
IsSummaryViewContext.displayName = 'IsSummaryViewContext';

export default IsSummaryViewContext;
